var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2636_2151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2863 6.99985L11.892 5.41128L12.0863 3.30842L10.0234 2.83985L8.94341 1.02271L7.00056 1.85699L5.0577 1.02271L3.9777 2.83985L1.91484 3.30271L2.10913 5.40556L0.714844 6.99985L2.10913 8.58842L1.91484 10.697L3.9777 11.1656L5.0577 12.9827L7.00056 12.1427L8.94341 12.977L10.0234 11.1598L12.0863 10.6913L11.892 8.58842L13.2863 6.99985ZM5.8577 9.85699L3.57199 7.57128L4.3777 6.76556L5.8577 8.23985L9.62341 4.47413L10.4291 5.28556L5.8577 9.85699Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2636_2151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(0.143555 0.1427)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.c15c2814a9b4d1145437d6fa8cfaf68e.svg";
export { ForwardRef as ReactComponent };